import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { StatisticState } from './types';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export const state: StatisticState = {
  customStatisticDetail: [],
  customStatisticGroup: [],
  customGroupings: {
    customGroup: [
      'hour',
      'day',
      'week',
      'month',
    ],
    customGroupOptionally: [
      'broker_account_login',
      'originator',
      'message_type',
      'template_id',
      'bulk_id',
    ],
  },
};

export const customStatistic: Module<StatisticState, RootState> = {
  state,
  getters,
  actions,
  mutations
};